import { useTranslation } from 'react-i18next';
import RadioQuestion from './RadioQuestion';

export default function Step2Building({ data, onUpdate, errors }) {
  const { t } = useTranslation();

  return (
    <div data-testid="quiz-step-2">
      <h2 className="text-2xl font-medium text-primary mb-6" style={{ fontFamily: 'Outfit' }}>{t('quiz.step2Title')}</h2>
      <div className="space-y-6">
        <RadioQuestion
          label={`${t('quiz.buildPeriod')} *`}
          value={data.build_period}
          options={[
            { value: 'Before 1975', label: t('quiz.buildPeriods.before1975') },
            { value: '1975-1990', label: '1975-1990' },
            { value: '1990-2005', label: '1990-2005' },
            { value: '2005-2015', label: '2005-2015' },
            { value: 'After 2015', label: t('quiz.buildPeriods.after2015') },
          ]}
          onChange={(val) => onUpdate({ build_period: val })}
          testIdPrefix="build-period"
          error={errors?.build_period}
        />

        <RadioQuestion
          label={`${t('quiz.size')} *`}
          value={data.size}
          options={['< 75 m²', '75-100 m²', '100-150 m²', '150-200 m²', '> 200 m²']}
          onChange={(val) => onUpdate({ size: val })}
          testIdPrefix="size"
          error={errors?.size}
        />
      </div>
    </div>
  );
}
